'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002415 from "./presto.-Register-Page-View$$anon$15.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002417 from "./presto.-Register-Page-View$$anon$17.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00245 from "./presto.-Register-Page-View$$anon$5.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00247 from "./presto.-Register-Page-View$$anon$7.js";
import * as $j_presto$002etypes$0024$002dSingle$002dApp$002dUser$0024 from "./presto.types$-Single-App-User$.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$4() {
  this.btK = null;
  this.btC = null;
  this.btD = false;
  this.btL = null;
  this.btM = false;
  this.btP = null;
  this.btI = null;
  this.btJ = false;
  this.btE = null;
  this.btF = false;
  this.btG = null;
  this.btH = false;
  this.btN = false;
  this.btO = false;
  this.btK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.btP = "SingleAppUser";
}
export { $c_Lpresto_RegisterPageView$$anon$4 as $c_Lpresto_RegisterPageView$$anon$4 };
$p = $c_Lpresto_RegisterPageView$$anon$4.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$4;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$4() {
}
export { $h_Lpresto_RegisterPageView$$anon$4 as $h_Lpresto_RegisterPageView$$anon$4 };
$h_Lpresto_RegisterPageView$$anon$4.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.btK;
});
$p.M = (function() {
  if ((!this.btD)) {
    this.btC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.btD = true;
  }
  return this.btC;
});
$p.O = (function() {
  if ((!this.btM)) {
    this.btL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.btM = true;
  }
  return this.btL;
});
$p.E = (function() {
  return this.btP;
});
$p.t = (function() {
  if ((!this.btJ)) {
    this.btI = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("details", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("application", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("impersonatedBy", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.btJ = true;
  }
  return this.btI;
});
$p.N = (function() {
  if ((!this.btF)) {
    this.btE = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00245.$c_Lpresto_RegisterPageView$$anon$5(), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00247.$c_Lpresto_RegisterPageView$$anon$7(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder(new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002415.$c_Lpresto_RegisterPageView$$anon$15())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.btF = true;
  }
  return this.btE;
});
$p.Q = (function() {
  if ((!this.btH)) {
    this.btG = new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002417.$c_Lpresto_RegisterPageView$$anon$17();
    this.btH = true;
  }
  return this.btG;
});
$p.v = (function() {
  if ((!this.btO)) {
    this.btN = false;
    this.btO = true;
  }
  return this.btN;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee117) => ((p) => \u03b4scrutinee117.ad0(p)))($j_presto$002etypes$0024$002dSingle$002dApp$002dUser$0024.$m_Lpresto_types$SingleAppUser$())));
});
var $d_Lpresto_RegisterPageView$$anon$4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$4, "presto.RegisterPageView$$anon$4", ({
  Qp: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$4 as $d_Lpresto_RegisterPageView$$anon$4 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$4.js.map
